/**
 * URL base do `manager-api`, configurável via `VITE_API_URL` (ver
 * `.env.example`). Fallback ao endereço padrão de desenvolvimento local.
 */
export const API_BASE_URL: string = import.meta.env.VITE_API_URL ?? 'http://localhost:3001';
